import React, { useEffect, useState } from "react";
import "./dashboard.scss";
import DashboardCard from "./components/DashboardCard";
import CommonLayout from "../../../layouts/commonLayout/CommonLayout";
import UpcommingTable from "./components/UpcommingTable";
import DoctorAppointment from "./components/DoctorAppointment";
import baseUrl from "../../../api/baseUrl";
import EventNoteIcon from "@mui/icons-material/EventNote";
import GroupIcon from "@mui/icons-material/Group";
import UniquePatientChart from "./components/UniquePatientChart";
import IncomeBarchart from "./components/IncomeBarchart";
import TreatmentPieChart from "./components/TreatmentPieChart";
import TabBar from "../../../components/tabbar/TabBar";
function Dashboard({ subitem }: any) {
  const [count, setcount] = useState({
    patients: 0,
    lastmonthPatients: 0,
    registerToday: 0,
    appointmentToday: 0,
    appointmentTomorrow: 0,
    cancelledToday: 0,
    cancelledthismonth: 0,
    waittingForConsultant: 0,
  });
  useEffect(() => {
    baseUrl
      .get("dashboard/findPatientsCount")
      .then((response) => {
        setcount({
          ...count,
          patients: response.data.count,
          lastmonthPatients: response.data.lastmonthRegister,
          registerToday: response.data.todayRegister,
          appointmentToday: response.data.appointmentToday,
          appointmentTomorrow: response.data.appointmentTomorrow,
          cancelledToday: response.data.cancelledToday,
          cancelledthismonth: response.data.cancelledthismonth,
          waittingForConsultant: response.data.waittingForConsultant,
        });
      })
      .catch((error) => {
        console.error(error.response);
      });
   
  }, []);
  const DASHBOARD_HOME = [
    // {
    //   name: "Waiting for Consultant",
    //   det: count?.waittingForConsultant,
    //   img: HourglassTopIcon,
    //   color: "#174d7a",
    // },
    // {
    //   name: "Appointment Today",
    //   det: count?.appointmentToday,
    //   img: EventAvailableIcon,
    //   color: "#02c58d",
    // },
    {
      name: "Total Appointments",
      det: count?.appointmentTomorrow,
      img: EventNoteIcon,
      color: "#fcbe2d",
    },
    // {
    //   name: "Cancelled Booking Today",
    //   det: count?.cancelledToday,
    //   img: EventBusyIcon,
    //   color: "#59c6fb",
    // },
    // {
    //   name: "Cancelled Booking This Month",
    //   det: count?.cancelledthismonth,
    //   img: CalendarTodayIcon,
    //   color: "#616f80",
    // },
    {
      name: "Total Patients",
      det: count.patients,
      img: GroupIcon,
      color: "#b163a4",
    },
    // {
    //   name: "Patients registered this month",
    //   det: count.lastmonthPatients,
    //   img: GroupIcon,
    //   color: "#9e10ab",
    // },
    {
      name: "Total Treatments ",
      det: 0,
      img: GroupIcon,
      color: "#9e10ab",
    },
    // {
    //   name: "Patients registered today",
    //   det: count.registerToday,
    //   img: GroupIcon,
    //   color: "#fc5454",
    // },
    // {
    //   name: "total income",
    //   det: 0,
    //   img: GroupIcon,
    //   color: "#fc5454",
    // },
  ];
  return (
    <CommonLayout>
     <TabBar items={subitem?.subnav} title={subitem?.title} />
      <div className="dashboard">
        <div className="sections">
          {DASHBOARD_HOME?.map((item, i) => (
            <DashboardCard
              key={i}
              name={item?.name}
              det={item?.det}
              SVG={item?.img}
              color={item?.color}
            />
          ))}
        </div>
        <div className="chart1">
          <UniquePatientChart  />
          <TreatmentPieChart  />
        </div>
        {/* <IncomeBarchart /> */}
        <UpcommingTable />
        <DoctorAppointment />
      </div>
    </CommonLayout>
  );
}

export default Dashboard;
